import { hasDiagramDarkMode } from '@y42/gojs';
import { Binding, GraphObject, Margin, Panel, Part, Picture, Shape, Size, Spot } from 'gojs';
import { orchestrationDiagramConfig } from '../../../config/orchestration-diagram.config';
import { OrchestrationUINode } from './../../../../models/orchestration-diagram.model';

const $ = GraphObject.make;
type portDir = 'IN' | 'OUT';

export const InPort = () => port('IN', true);
export const OutPort = () => port('OUT');

const iconMap = new Map<portDir, { size: Size; path: string }>([
  [
    'IN',
    {
      size: new Size(14, 14),
      path: orchestrationDiagramConfig.icons.squareIcon,
    },
  ],
  [
    'OUT',
    {
      size: new Size(8, 15),
      path: orchestrationDiagramConfig.icons.arrowIcon,
    },
  ],
]);

const port = (dir: portDir, multiInputs = false) =>
  $(
    Panel,
    Panel.Auto,
    {
      portId: dir.toString(),
      margin: new Margin(2),
      cursor: 'pointer',
      toMaxLinks: multiInputs ? undefined : 1,
      toSpot: Spot.Left,
      fromSpot: Spot.Right,
      toLinkable: dir === 'IN',
      fromLinkable: dir === 'OUT',
    },
    portShape(),
    portLabel(dir),
  );

const portShape = () =>
  $(
    Shape,
    'Circle',
    {
      stroke: null,
      desiredSize: new Size(24, 24),
    },
    portFill(),
  );

const portFill = () =>
  new Binding('fill', '', (__node: OrchestrationUINode, part: Part) => {
    const hasDarkMode = hasDiagramDarkMode(part.diagram);

    return hasDarkMode ? orchestrationDiagramConfig.port.dark.fill : orchestrationDiagramConfig.port.light.fill;
  }).ofObject();

const portLabel = (dir: portDir) =>
  $(Picture, {
    desiredSize: iconMap.get(dir)?.size,
    source: iconMap.get(dir)?.path,
  });
